import React, { FunctionComponent } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../organisms/trans'
import { FullPage } from '../../../templates'

const tKey = TKey('pages.payment-disabled')

export const PaymentDisabled: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  return (
    <FullPage
      pageId='payment-disabled'
      header={t(tKey('header'))}
      subheader={<WriskTrans i18nKey={tKey('subheader')} t={t} />}
    />
  )
}
